import type { TemplateProfile, GraphLayoutType } from './types';
import { AppError, AppErrorCode } from '../core/errors/AppError';

/** Registry managing available template profiles. */
export class TemplateRegistry {
  private _profiles: Map<string, TemplateProfile> = new Map();

  constructor(profiles: TemplateProfile[] = []) {
    for (const p of profiles) this.register(p);
  }

  register(profile: TemplateProfile): void {
    if (this._profiles.has(profile.id)) {
      throw new AppError(`Duplicate template id: ${profile.id}`, AppErrorCode.DUPLICATE_TEMPLATE_ID, profile.id);
    }
    this._profiles.set(profile.id, profile);
  }

  get(id: string): TemplateProfile {
    const p = this._profiles.get(id);
    if (!p) throw new AppError(`Template not found: ${id}`, AppErrorCode.TEMPLATE_NOT_FOUND, id);
    return p;
  }

  getAll(): TemplateProfile[] {
    return Array.from(this._profiles.values());
  }

  has(id: string): boolean {
    return this._profiles.has(id);
  }

  getSupportedLayouts(id: string): GraphLayoutType[] {
    return this.get(id).supportedLayoutTypes;
  }
}
